import { DateTime } from 'luxon';

export const dateTimeToTime = (dateTime: string) => {
  return DateTime.fromISO(dateTime).toFormat('HH:mm');
};
